export default __webpack_public_path__ + "static/media/code-sandbox-square.41937d8e.svg";